<template>
    <div>
        <h2 class="white--text"  style="padding: 7px 15px;border-radius: 5px 5px 0px 0px;background: #63376A">
            Сбор данных
        </h2>
        <v-stepper :vertical="true" :alt-labels="false" v-model="currentStep">
            <v-stepper-step :complete="currentStep > 1" :step="1" :editable="true" color="#63376A" >
              <span class="title">Артериальное давление</span>
            </v-stepper-step>
            <v-stepper-content :step="1">
              <pressure @pressureIsSet="setPressure($event)"></pressure>
            </v-stepper-content>
            <div v-if="hypertensionExist">
              <v-stepper-step :complete="currentStep > 2" :step="2" :editable="true" color="#63376A">
                <span class="title">Определите наличие факторов риска (ФР)</span>
              </v-stepper-step>
              <v-stepper-content :step="2">
                <risk-factors @riskFactorsAreSet="setFactors($event)"></risk-factors>
              </v-stepper-content>

              <v-stepper-step :complete="currentStep > 3" :step="3" :editable="true" color="#63376A">
                <span class="title">Определите наличие поражения органов мишеней (ПОМ)</span>
              </v-stepper-step>
              <v-stepper-content :step="3">
                <target-organ-damages @targetOrganDamagesAreSet="setTargetOrganDamages($event)"></target-organ-damages>
              </v-stepper-content>

              <v-stepper-step :complete="currentStep > 4" :step="4" :editable="true" color="#63376A">
                <span class="title">Определите наличие ассоциированных клинических состояний (АКС)</span>
              </v-stepper-step>
              <v-stepper-content :step="4">
                <associated-clinical-conditions @clinicalConditionsAreSet="setClinicalConditions($event)"></associated-clinical-conditions>
              </v-stepper-content>
            </div>
        </v-stepper>
    </div>
</template>

<script>
import Pressure from './Pressure'
import RiskFactors from './RiskFactors'
import TargetOrganDamages from './TargetOrganDamages'
import AssociatedClinicalConditions from './AssociatedClinicalConditions'

export default {
  name: 'DataCollect',
  components: { Pressure, RiskFactors, TargetOrganDamages, AssociatedClinicalConditions },
  data: () => (
    {
      steps: 5,
      currentStep: 1
    }
  ),
  created () {
    // this.hypertensionExist = this.$store && this.$store.state.results.pressure.degree !== '' ? this.$store.state.results.pressure.degree : true
  },
  computed: {
    hypertensionExist: function () {
      let result = true
      if (this.$store.state.results.pressure.degree === 'none' || this.$store.state.results.pressure.degree === '0') {
        result = false
      }
      return result
    }
  },
  updated () {
    if (this.hypertensionExist === true && this.currentStep === 2) {
      let steppers = this.$children[0].$children
      for (let k in steppers) {
        let stepper = steppers[k]
        if (stepper.step === 2 && stepper.hasOwnProperty('isActive') && stepper.isActive === null) {
          stepper.isActive = true
          break
        }
      }
    }
  },
  methods: {
    nextStep (n) {
      if (n === this.steps) {
        this.currentStep = n
      } else {
        this.currentStep = n + 1
      }
    },
    setPressure (pressure) {
      this.$store.commit('setPressure', pressure)
      this.$store.commit('setPressureDegree', pressure.degree)
      if (this.hypertensionExist) {
        this.nextStep(1)
      }
    },
    setFactors (factors) {
      this.$store.commit('setRiskFactors', factors)
      this.nextStep(2)
    },
    setTargetOrganDamages (damages) {
      this.$store.commit('setTargetOrganDamages', damages)
      this.nextStep(3)
    },
    setClinicalConditions (conditions) {
      this.$store.commit('setAssociatedClinicalConditions', conditions)
      this.nextStep(4)
      let resultsBlock = document.getElementById('results-wrapper')
      if (resultsBlock) {
        resultsBlock.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' })
      }
      // let steppers = this.$children[0].$children
      // for (let k in steppers) {
      //   let stepper = steppers[k]
      //   if (stepper.step === 1 && stepper.hasOwnProperty('isActive') && stepper.isActive === true) {
      //     stepper.isActive = true
      //     break
      //   }
      // }
    }
  }
}
</script>

<style lang="scss">
  .tooltip-wrapper {
    opacity: 1!important;
    background: rgb(97,97,97)!important;
  }
</style>
